import React from "react";

const CardSVG = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="41.777"
      height="32.494"
      viewBox="0 0 41.777 32.494"
    >
      <path
        fill="#fff"
        d="M38.289 32h-34.8A3.484 3.484 0 000 35.481v25.531a3.484 3.484 0 003.489 3.481h34.8a3.484 3.484 0 003.489-3.481V35.481A3.484 3.484 0 0038.289 32zM3.924 35.481h33.93a.436.436 0 01.435.435v3.046h-34.8v-3.045a.436.436 0 01.435-.436zm33.93 25.531H3.924a.436.436 0 01-.435-.435v-12.33h34.8v12.33a.436.436 0 01-.435.435zm-23.928-7.253v2.9a.873.873 0 01-.87.87H7.833a.873.873 0 01-.87-.87v-2.9a.873.873 0 01.87-.87h5.222a.873.873 0 01.871.87zm13.926 0v2.9a.873.873 0 01-.87.87h-9.865a.873.873 0 01-.87-.87v-2.9a.873.873 0 01.87-.87h9.864a.873.873 0 01.871.87z"
        transform="translate(0 -32)"
      ></path>
    </svg>
  );
};

export default CardSVG;
